import React from 'react'
import {
  numWinners,
  timesActivity,
} from '../../../constants/activity-constants'
import { jsonToHash } from '../../../utils/crypto'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import Show from '../../../utils/show'

import './modal-points.scss'

const LOCALE =
  [
    'es-AR',
    'es-CL',
    'es-PE',
    'es-EC',
    'es-CL',
    'es-DO',
    'es-BO',
    'es-PR',
    'es-PY',
  ].indexOf(process.env.LOCALE) > -1
    ? process.env.LOCALE
    : 'default'

const italatam = LOCALE === 'es-AR' || LOCALE === 'es-PY'

const userInfo = getUserInfo()
const handleClickLink = async label => {
  const user_data =
    userInfo !== null
      ? await jsonToHash([
          {
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location.cityName,
            departamento: userInfo.location.countryStateName,
            pais: userInfo.countryName,
          },
        ])
      : null
  pushEventData({
    event: 'Interacciones_pop_up_VMatch',
    label,
    user_data,
    log_status: userInfo ? 'Yes' : 'Not',
  })
}
const handleClick = async label => {
  const user_data =
    userInfo !== null
      ? await jsonToHash([
          {
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location.cityName,
            departamento: userInfo.location.countryStateName,
            pais: userInfo.countryName,
          },
        ])
      : null
  pushEventData({
    event: 'Interacciones_pop_up_VMatch',
    label,
    action: 'view',
    user_data,
    log_status: userInfo ? 'Yes' : 'Not',
  })
}

export default function ModalPoints(props) {
  const { userName, userPoints, userPosition } = props
  handleClick('Hola ' + userName)
  return (
    <div className="modal-points">
      <div className="modal-points-container">
        <div className="wrapper-star">
          <h2 className="wrapper-star__title">
            Hola, <br />
            <span>{userName}</span>
          </h2>
          <div className="wrapper-star__body">
            <p>
              Tus puntos:
              <span>{userPoints}</span>
            </p>

            <p>
              <Show valid={!italatam}>
                Tu posición:
                <span>{userPosition}</span>
              </Show>
              <Show valid={italatam}>
                Tu puesto:
                <span>{userPosition}</span>
              </Show>
            </p>
          </div>
          <Show valid={!italatam}>
            <p className="wrapper-star__body__textInfo">
              Si no estás en nuestro top {numWinners}{' '}
              <span>¡sigue jugando y no te rindas!</span> tienes hasta el{' '}
              {timesActivity.fin.dia} de {timesActivity.fin.mes} para alcanzar
              los mejores puntajes. <br />
              <br />
              ¡Participa y diviértete!
            </p>
            <button
              className="btn-secondary--2"
              onClick={() => {
                props.closeModal()
                handleClickLink('Aceptar')
              }}
            >
              Aceptar
            </button>
          </Show>
          <Show valid={italatam}>
            <p className="wrapper-star__body__textInfo">
              Si no estás en nuestro top {numWinners}{' '}
              <span>¡seguí jugando y no te rindás!</span> tenés hasta el{' '}
              {timesActivity.fin.dia} de {timesActivity.fin.mes} para alcanzar
              los mejores puntajes. <br />
              <br />
              ¡Participá y divertite!
            </p>
            <button
              className="btn-secondary--2"
              onClick={() => {
                props.closeModal()
                handleClickLink('Aceptar')
              }}
            >
              Aceptar
            </button>
          </Show>
        </div>
        {/* <p className="family-H-Medium size-18 color-white">
          Por ti, por mí, por nosotras,
        </p>
        <p className="family-S-House size-40 color-yellow">¡Comparte Loving!</p> */}
      </div>
    </div>
  )
}
